export default process.env.ENERGY_API_BASE ||
  (process.env.NODE_ENV === "production"
    ? "/api/energy/"
    : "http://localhost:60057/");
